var render, staticRenderFns
import script from "./CustomGenericDocumentAtas.vue?vue&type=script&lang=js"
export * from "./CustomGenericDocumentAtas.vue?vue&type=script&lang=js"
import style0 from "./CustomGenericDocumentAtas.vue?vue&type=style&index=0&id=41e77cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e77cce",
  null
  
)

export default component.exports